/** Целые суммы в рублях: отображение с пробелами между разрядами (10 000). */

export function formatGroupedInt(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return ''
  const abs = Math.floor(Math.abs(n))
  return abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export function parseGroupedIntInput(s: string): number | null {
  const digits = s.replace(/\s/g, '').replace(/[^\d]/g, '')
  if (digits === '') return null
  const n = parseInt(digits, 10)
  return Number.isNaN(n) ? null : n
}

/** Для подписей «10 000 ₽» в режиме просмотра */
export function formatRubAmountCell(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—'
  return formatGroupedInt(n)
}
